import React from 'react'

import { input } from '@albacross/frontend-utils'

import BaseSelect from './BaseSelect'

export default input([])((props: any) => (
  <BaseSelect {...props} multiple onChange={props.onChange} value={props.value || []} />
))
